var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScale(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 20",
    fill: "#3C3C3C",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99 16.54l-7.37-5.73L0 12.07l9 7 9-7-1.63-1.27-7.38 5.74zM9 14l7.36-5.73L18 7 9 0 0 7l1.63 1.27L9 14z",
    fill: "inherit"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTkiIHZpZXdCb3g9IjAgMCAxOCAyMCIgZmlsbD0iIzNDM0MzQyIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTguOTkgMTYuNTRMMS42MiAxMC44MUwwIDEyLjA3TDkgMTkuMDdMMTggMTIuMDdMMTYuMzcgMTAuOEw4Ljk5IDE2LjU0Wk05IDE0TDE2LjM2IDguMjdMMTggN0w5IDBMMCA3TDEuNjMgOC4yN0w5IDE0WiIgZmlsbD0iaW5oZXJpdCIvPgo8L3N2Zz4K";
export { SvgScale as ReactComponent };